namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

	export interface ISiteAccount extends IBaseAccount {
		party: Site;

		mapToEnterpriseCoordinatorSiteAccountUpsearchRequestModel(canInsertAccount: boolean, canUpdateAccount: boolean, skipAccountSearch: boolean, canInsertParty: boolean, canUpdateParty: boolean, skipPartySearch: boolean);
	}

	export class SiteAccount extends BaseAccount implements ISiteAccount {
		party: Site;

		constructor(obj?: ISiteAccount | any) {
			super(obj);

			this.party = new Site();

			if (obj) {
				if (obj.party) {
					this.party = new Site(obj.party);
				}
			}
		}

		mapToEnterpriseCoordinatorSiteAccountUpsearchRequestModel(canInsertAccount: boolean, canUpdateAccount: boolean, skipAccountSearch: boolean, canInsertParty: boolean, canUpdateParty: boolean, skipPartySearch: boolean) {
			const accountDiagnosisSession = this.getDiagnosisSession(false);

			const accountUpsearchModel: psgm.EnterpriseCoordinatorSiteAccountUpsearchRequestModel = {
				accountData: this.mapToEnterpriseCoordinatorAccountUpsearchModelWithFlags(canInsertAccount, canUpdateAccount, skipAccountSearch),
				diagnosisSessionData: accountDiagnosisSession ? accountDiagnosisSession.mapToEnterpriseCoordinatorDiagnosisSessionModel() : null,
				partyData: this.party ? this.party.mapToEnterpriseCoordinatorSiteUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch) : null,
				payorData: this.payorRelationships ? _.map(this.payorRelationships, pr => {
					return pr.mapToEnterpriseCoordinatorPayorUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
				}) : [],
				pharmacyData: this.pharmacyRelationships ? _.map(this.pharmacyRelationships, pr => {
					return pr.mapToEnterpriseCoordinatorPharmacyUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
				}) : [],
				prescriberData: this.prescriberRelationships ? _.map(this.prescriberRelationships, pr => {
					return pr.mapToEnterpriseCoordinatorPrescriberUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
				}) : [],
				prescriptionData: this.prescriptions ? _.map(this.prescriptions, p => {
					return p.mapToEnterpriseCoordinatorPrescriptionUpsearchModel();
				}) : [],
				siteData: this.siteRelationships ? _.map(this.siteRelationships, sr => {
					return sr.mapToEnterpriseCoordinatorSiteUpsearchModelWithFlags(canInsertParty, canUpdateParty, skipPartySearch);
				}) : [],
				surveySessionData: this.getSurveySessionIds()
			}
			return accountUpsearchModel;
		}
	}

	export interface ISiteAccountRegistration {
		portalId: string;
		userName: string;
		firstName: string;
		lastName: string;
		phone: ContactInfo;
		fax: ContactInfo;
		email: ContactInfo;
		siteAccount: SiteAccount;
	}

	export class SiteAccountRegistration implements ISiteAccountRegistration {
		portalId: string;
		userName: string;
		firstName: string;
		lastName: string;
		phone: ContactInfo;
		fax: ContactInfo;
		email: ContactInfo;
		siteAccount: SiteAccount;

		constructor(obj?: ISiteAccountRegistration) {
			this.portalId = '';
			this.userName = '';
			this.firstName = '';
			this.lastName = '';
			this.phone = new ContactInfo();
			this.fax = new ContactInfo();
			this.email = new ContactInfo();
			this.siteAccount = new SiteAccount();

			if (obj) {
				this.portalId = obj.portalId || '';
				this.userName = obj.userName || '';
				this.firstName = obj.firstName || '';
				this.lastName = obj.lastName || '';

				if (obj.phone) {
					this.phone = new ContactInfo(obj.phone);
				}

				if (obj.fax) {
					this.fax = new ContactInfo(obj.fax);
				}

				if (obj.email) {
					this.email = new ContactInfo(obj.email);
				}

				if (obj.siteAccount) {
					this.siteAccount = new SiteAccount(obj.siteAccount);
				}
			}
		}
	}
}
